module.exports = __webpack_public_path__ + "img/trial4-4.2b31680c.png";